import { render, staticRenderFns } from "./Rebound.vue?vue&type=template&id=20a3ad9a&name=rebound&"
import script from "./Rebound.vue?vue&type=script&lang=js&"
export * from "./Rebound.vue?vue&type=script&lang=js&"
import style0 from "./Rebound.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports